// --------------------------------------------------------
// VITAL SIGN LIST - VitalSignList
// --------------------------------------------------------

import React, { useCallback, useEffect, useState } from "react";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  GeneralContainer,
  Text,
} from "../../components/UI/generalLayout/Layout.styled";
import Colors from "../../constants/Colors";
import ScreenHeader from "../../components/UI/screenHeader/ScreenHeader";
import LabelInput from "../../components/labelInput/LabelInput";
import SearchIcon from "@mui/icons-material/Search";
import ItemList from "../../components/itemList/ItemList";
import { CompanyListItemContainer } from "../company/CompanyList.styled";
import VitalSignListItem from "../../components/vitalSignListItem/VitalSignListItem";
import { useSelector } from "react-redux";
import VitalSign from "../../models/core/careLine/VitalSign";
import { useAppDispatch } from "../..";
import * as vitalSignActions from "../../store/actions/vitalSign";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../enums/Paths";
import { executeWithDelay } from "../../helpers/HelperFunctions";

function VitalSignList(): JSX.Element {
  const [searchQuery, setSearchQuery] = useState("");
  const [headerFields] = useState([
    { name: "Sinal Vital", width: "40%", align: null },
    { name: "Tipo", width: "20%", align: null },
    { name: "Padrão", width: "10%", align: "center" },
    { name: "Status", width: "30%", align: "right" },
  ]);
  
  const vitalSignList: VitalSign[] = useSelector(
    (state: any) => state.vitalSign.vitalSigns
  );
  
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const getData = useCallback(async () => {
    await dispatch(vitalSignActions.fetchVitalSigns());
  }, [dispatch]);

  const filterDataByName = useCallback(async () => {
    if (searchQuery.length >= 3 || searchQuery === "") {
      executeWithDelay(500, async () => {
        await dispatch(vitalSignActions.filterVitalSignByName(searchQuery));
      });
    }
  }, [searchQuery, dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    filterDataByName();
  }, [searchQuery, filterDataByName]);

  const navigateToRegister = () => {
    return navigate(Paths.VitalSignRegister);
  };

  const navigateToEdit = (vitalSign: any) => {
    return navigate(Paths.VitalSignRegister, { state: { vitalSign: vitalSign } });
  };

  const navigateToView = (vitalSign: any) => {
    return navigate(Paths.VitalSignRegister, {
      state: { vitalSign: vitalSign, isView: true },
    });
  };

  const activateOrInactivate = async (id: string, isActive: boolean) => {
    await dispatch(vitalSignActions.activateOrDeactivateVitalSign(isActive, id));
    getData();
  };

  return (
    <ContainerWithSidebar>
      <GeneralContainer>
        <ScreenHeader
          screenTitle={"Sinais Vitais"}
          rightButtonText={"Cadastrar novo sinal vital"}
          onRightButtonClick={navigateToRegister}
        />
        <LabelInput
          value={searchQuery}
          placeholder="Busca de sinal vital"
          onChangeText={(event: any) => {
            setSearchQuery(event.target.value);
          }}
          rightIcon={<SearchIcon />}
        />
        {searchQuery.length > 2 && (
          <div style={{ paddingLeft: 12, paddingRight: 12 }}>
            <Text color={Colors.lightBlue}>
              Resultados para: {searchQuery}{" "}
            </Text>
          </div>
        )}
        <ItemList listHeader={headerFields} list={vitalSignList}>
          <CompanyListItemContainer>
            {vitalSignList.map((vs) => (
              <VitalSignListItem
                key={vs.id!}
                id={vs.id!}
                name={vs.nome!}
                tipoCampo={vs.tipoCampo!}
                isPadrao={vs.padrao}
                isActiveRegister={!vs.inativo}
                onView={() => navigateToView(vs)}
                onEdit={() => navigateToEdit(vs)}
                onActivateInactivate={activateOrInactivate}
              />
            ))}
          </CompanyListItemContainer>
        </ItemList>
      </GeneralContainer>
    </ContainerWithSidebar>
  );
}

export default VitalSignList;
